import { IProfileUser, IUser } from '@giphy/js-types'
import SmartLink from './smart-link'

type Props = {
    user: IUser
    alternateName?: string
}
const DisplayName = ({ user, alternateName = '' }: Props) => {
    const userLink = (user as IProfileUser).profile_url || `/${user.username}`
    return (
        <SmartLink noLink={true} href={userLink}>
            <div className="flex flex-col justify-center font-semibold">{alternateName || user.display_name}</div>
        </SmartLink>
    )
}

export default DisplayName
